import { render } from "./Coin.vue?vue&type=template&id=087c7db4"
const script = {}

import "./Coin.vue?vue&type=style&index=0&id=087c7db4&lang=stylus"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__